import { combineReducers } from 'redux';
import assign from 'object-assign';
import sampleReducer from '../modules/sampleModule/reducer';
import mainReducer from '../modules/mainModule/reducer';
import loginReducer from '../modules/loginModule/reducer';
import homeReducer from '../modules/homeModule/reducer';
import profileReducer from '../modules/profileModule/reducer';
import manageReducer from '../modules/manageModule/reducer';
import registerReducer from '../modules/registerModule/reducer';
import accountReducer from '../modules/accountModule/reducer';
import applicationReducer from '../modules/applicationModule/reducer';

let reducers = {
	sampleReducer,
	mainReducer,
	loginReducer,
	homeReducer,
	profileReducer,
	manageReducer,
	registerReducer,
	accountReducer,
	applicationReducer
};

function combineReducer(reducer) {
	if (typeof reducer === 'object') {
		let reducerKeys = Object.keys(reducer);
		for (var i = 0; i < reducerKeys.length; i++) {
			if (typeof reducers[reducerKeys[i]] === 'undefined') {
				const insertReducer = {};
				insertReducer[reducerKeys[i]] = reducer[reducerKeys[i]];
				return combineReducers(assign(reducers, insertReducer));
			}
		}
	}
	return combineReducers(reducers); 
}

export default combineReducer;
